import { combineReducers } from 'redux';

import {initState} from './initReducer';
import {buildValues} from "./buildValuesGeneral";
import {buildValuesSides} from "./buildValuesSides";

export default combineReducers({
    initState,
    buildValues,
    buildValuesSides
});


// WEBPACK FOOTER //
// ./src/reducers/index.js